module.exports = __webpack_public_path__ + "static/media/Pettway_Yasminye_edited-1-433x450.02cf689f.jpg";